
interface TitleDotTextProps {
  title: string;
  text: string;
}

export default function TitleDotText({ title, text }: TitleDotTextProps) {
  return (
    <>
      <div className="w-full flex items-start justify-start gap-[8px] mb-[15px]">
        <div className="flex items-center justify-start h-[22px]">
          <div className="rounded-[50%] w-[4px] h-[4px] bg-[#000]" />
        </div>
        <div className="flex flex-col items-start justify-start">
          <div className="text-[14px] text-[1C1C1C] w-full text-left font-[700] mb-[5px]">
            {title}
          </div>
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {text}
          </div>
        </div>
      </div>
    </>
  );
}

